module.exports = __webpack_public_path__ + "img/g-white.c9464889.png";